<button type="button"
      type="button"
      class="{{class}}"
      [ngbPopover]="content"
      [popoverTitle]="title"
      [placement]="placement"
      [popoverClass]="popoverClass"
      [autoClose]="autoClose"
      
    >
      {{ buttonText }}
    </button>